<template>
  <svg
    width="18"
    height="18"
    xmlns="http://www.w3.org/2000/svg"
    style="display: block"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 11.293l10.293-10.293.707.707-10.293 10.293 10.293 10.293-.707.707-10.293-10.293-10.293 10.293-.707-.707 10.293-10.293-10.293-10.293.707-.707 10.293 10.293z"
    />
  </svg>
</template>
